/*
 * Routes-users.ts
 * Description: Includes the declaration of the
 * users routes for Vue Router
 */

// Importing components
import PageUsers from '@/pages/users/PageUsers.vue';
import PageUsersCreate from '@/pages/users/PageUsersCreate.vue';
import PageUsersUpdate from '@/pages/users/PageUsersUpdate.vue';

const routesUsers = [
    // Defining the users page route
    {
        path: '/users',
        name: 'users',
        component: PageUsers,
        meta: { requiresAuth: true, ManageUsers: true },
    },
    // Defining the users create page route
    {
        path: '/users/create',
        name: 'users-create',
        component: PageUsersCreate,
        meta: { requiresAuth: true, ManageUsers: true },
    },
    // Defining the users update page route
    {
        path: '/users/:id/update',
        name: 'users-update',
        component: PageUsersUpdate,
        props: { id: Number },
        meta: { requiresAuth: true, ManageUsers: true },
    },
];
export default routesUsers;
